import { mapGetters } from "vuex";

export const staticPagesMixin = {
  data() {
    return {
      title: null,
      page_content: null,
    };
  },
  async fetch() {
    try {
      let pageKeyOnApi = this.$route?.path?.replace("/", "");
      const response = await this.$axios.get("/api/page", {
        params: {
          page: pageKeyOnApi,
        },
      });
      this.page_content = response?.data?.page;
      this.title = response?.data?.title;
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    ...mapGetters({
      seoTexts: "global/getSeoTexts",
    }),

    h1() {
      return this.seoTexts?.h1 || this.title;
    },
  },
  methods: {
    isPage(path) {
      return this.$route?.path?.includes(path);
    },
  },
  mounted() {
    console.log(this.$route);
  },
};
